import logo from "./logo.svg";
import "./App.css";
import { useRef, useState } from "react";
import useMediaQuery from "@mui/material/useMediaQuery";
import { Carousel } from "react-responsive-carousel";
require("react-responsive-carousel/lib/styles/carousel.min.css");

function App() {
  const aboutRef = useRef(null);
  const teamRef = useRef(null);
  const [showDocs, setShowDocs] = useState("about");
  const matches = useMediaQuery("(max-width:1060px)");

  return (
    <div className="page-container">
      <div className="header">
        <div
          className="logo-container"
          onClick={() => {
            setShowDocs("about");
            window.scrollTo(0, 0);
          }}
        >
          <img
            src={require("./assets/images/logo1.png")}
            className="header-logo"
          />
        </div>
        {!matches && (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "flex-end",
              padding: 10,
              width: "33%"
            }}
          >
            <span
              style={{ fontSize: 56, color: "#3f5c94", fontFamily: "Poppins" }}
            >
              SORENSIS
            </span>
          </div>
        )}
        <div className="link-container">
          <div
            onClick={() => {
              setShowDocs("about");
              aboutRef.current?.scrollIntoView({ behavior: "smooth" });
            }}
            className="link"
          >
            About Us
          </div>
          <div
            onClick={() => {
              setShowDocs("about");
              teamRef.current?.scrollIntoView({ behavior: "smooth" });
            }}
            className="link"
          >
            Our Team
          </div>
          <div
            onClick={() => {
              setShowDocs("docs");
            }}
            className="link"
          >
            Documents
          </div>
          <div
            onClick={() => {
              setShowDocs("news");
            }}
            className="link"
          >
            News/Updates
          </div>
        </div>
      </div>
      {showDocs == "about" ? (
        <div className="body">
          <div className="hero-container">
            <img
              src={require("./assets/images/hero2.jpg")}
              className="hero-image"
            />
          </div>
          <hr />
          <div
            className="body-section"
            style={{ maxHeight: 500 }}
            ref={aboutRef}
          >
            <div className="text-container">
              <div className="content">
                Improving Quality of Life through developing versatile solutions
                to unmet needs
              </div>
            </div>
            <div className="image-container">
              <img
                src={require("./assets/images/body1.jpg")}
                className="body-image"
              />
            </div>
          </div>
          <hr />
          <hr />
          <div className="content-subheading" ref={teamRef}>
            Our Team
          </div>
          <hr />

          <div className="body-section">
            <div className="team-image-container">
              <img
                src={require("./assets/images/kim.jpeg")}
                className="team-image"
              />
            </div>
            <div className="team-text-container">
              <div className="team-content">
                <span className="team-desc-heading">Dr. Kim Agnew</span>
                <span className="team-desc-subheading">
                  CEO/Founder Sorensis
                </span>
                <hr />

                <span className="team-desc">
                  Veterinarian/Biochemist - Highly experienced Animal Health
                  Executive (Product Development, Regulatory, Team Leadership,
                  R&amp;D)
                </span>
              </div>
            </div>
          </div>

          <div className="body-section">
            <div className="team-image-container">
              <img
                src={require("./assets/images/rob.jpeg")}
                className="team-image"
              />
            </div>
            <div className="team-text-container">
              <div className="team-content">
                <span className="team-desc-heading">Dr. Rob Hunter</span>
                <span className="team-desc-subheading">CSO Sorensis</span>
                <hr />

                <span className="team-desc">
                  Globally recognized Veterinary Pharmacologist and Veterinary
                  Drug Regulatory Subject Matter expert
                </span>
              </div>
            </div>
          </div>

          <hr />
          <div className="content-subheading">Collaborators / Advisors</div>
          <hr />

          <div className="body-section">
            <div className="team-image-container">
              <img
                src={require("./assets/images/shawn.jpeg")}
                className="team-image"
              />
            </div>

            <div className="team-text-container">
              <div className="team-content">
                <span className="team-desc-heading">Shawn Glinter</span>
                <span className="team-desc-subheading">
                  CEO/Founder Pendant Biosciences
                </span>
                <hr />
                <span className="team-desc">7 x Successful Entrepreneur</span>
                <span className="team-desc">
                  Heathcare, LifeSciences, Technology
                </span>
              </div>
            </div>
          </div>
          <div className="body-section">
            <div className="team-image-container">
              <img
                src={require("./assets/images/D'Occhio.jpg")}
                className="team-image"
              />
            </div>

            <div className="team-text-container">
              <div className="team-content">
                <span className="team-desc-heading">Honorary Professor</span>
                <span className="team-desc-heading">Michael J D'Occhio</span>
                <span className="team-desc-subheading">
                  University of Sydney
                </span>
                <hr />
                {/* <span className="team-desc">7 x Successful Entrepreneur</span>
                <span className="team-desc">
                  Heathcare, LifeSciences, Technology
                </span> */}
              </div>
            </div>
          </div>

          <hr />
        </div>
      ) : showDocs == "docs" ? (
        <div className="body">
          <div className="video-container">
            <iframe
              src="https://drive.google.com/file/d/1IO4__xo7pgekZcagXaQdHHUTxZ_RgLEM/preview"
              // width="897"
              // height="500"
              className="video-frame"
              allowfullscreen="allowfullscreen"
              mozallowfullscreen="mozallowfullscreen"
              msallowfullscreen="msallowfullscreen"
              oallowfullscreen="oallowfullscreen"
              webkitallowfullscreen="webkitallowfullscreen"
              allow="autoplay"
            ></iframe>
          </div>

          <hr />
          <div className="content-heading" ref={teamRef}>
            Sorensis Pitch
            <a href={require("./assets/documents/pitch.pdf")} download>
              <img
                style={{ width: 50, paddingLeft: 30, cursor: "pointer" }}
                src={require("./assets/images/blank-page.png")}
              />
            </a>
          </div>
          <hr />
          <div className="body-section">
            <Carousel
              swipeable={false}
              showStatus={false}
              infiniteLoop={true}
              showThumbs={false}
              dynamicHeight={false}
              className="carousel"
            >
              <img src={require("./assets/pitch/0001.jpg")} />
              <img src={require("./assets/pitch/0002.jpg")} />
              <img src={require("./assets/pitch/0003.jpg")} />
              <img src={require("./assets/pitch/0004.jpg")} />
              <img src={require("./assets/pitch/0005.jpg")} />
              <img src={require("./assets/pitch/0006.jpg")} />
              <img src={require("./assets/pitch/0007.jpg")} />
              <img src={require("./assets/pitch/0008.jpg")} />
              <img src={require("./assets/pitch/0009.jpg")} />
              <img src={require("./assets/pitch/0010.jpg")} />
              <img src={require("./assets/pitch/0011.jpg")} />
              <img src={require("./assets/pitch/0012.jpg")} />
              <img src={require("./assets/pitch/0013.jpg")} />
              <img src={require("./assets/pitch/0014.jpg")} />
              <img src={require("./assets/pitch/0015.jpg")} />
              <img src={require("./assets/pitch/0016.jpg")} />
              <img src={require("./assets/pitch/0017.jpg")} />
              <img src={require("./assets/pitch/0018.jpg")} />
              <img src={require("./assets/pitch/0019.jpg")} />
              <img src={require("./assets/pitch/0020.jpg")} />
            </Carousel>
          </div>
          <hr />
          <div className="content-heading" ref={teamRef}>
            One Pager
            <a href={require("./assets/documents/one_sheet.pdf")} download>
              <img
                style={{ width: 50, paddingLeft: 30, cursor: "pointer" }}
                src={require("./assets/images/blank-page.png")}
              />
            </a>
          </div>
          <hr />
          <div
            className="body-section"
            style={{
              height: "75vh",
              display: "flex",
              justifyContent: "space-around",
            }}
          >
            <a
              style={{ height: "100%", width: "fit-content" }}
              href={require("./assets/one_sheet/0001.jpg")}
              target="_blank"
            >
              <img
                style={{ height: "100%", width: "100%", objectFit: "contain" }}
                src={require("./assets/one_sheet/0001.jpg")}
              />
            </a>
            <a
              style={{
                display: "flex",
                justifyContent: "center",
                height: "100%",
                width: "fit-content",
              }}
              href={require("./assets/one_sheet/0002.jpg")}
              target="_blank"
            >
              <img
                style={{ height: "100%", width: "100%", objectFit: "contain" }}
                src={require("./assets/one_sheet/0002.jpg")}
              />
            </a>
          </div>
          {/* <div className="body-section">
            <img
              style={{ width: "100%" }}
              src={require("./assets/one_sheet/one_sheet-1.jpg")}
            />
          </div> */}
        </div>
      ) : (
        <div className="body">
          <div className="content-heading" ref={teamRef}>
            News & Updates
          </div>
          <hr />
          <img
            src={require("./assets/images/showcase.png")}
            style={{ width: "100%" }}
          />
          <div
            style={{
              width: "80%",
              padding: 20,
              textAlign: "center",
              fontSize: 18,
            }}
          >
            We’re excited to be presenting at Animal Health, Nutrition and
            Technology Innovation USA on 13-14 June in Boston.
            <br /> We hope to see you there! Join us: <br />
            <a
              href="https://hubs.ly/Q01Nvyzp0"
              style={{ textDecoration: "underline" }}
            >
              https://hubs.ly/Q01Nvyzp0
            </a>
            <br /> #AHNTI #Animalhealthinnovation
          </div>
          <hr style={{width: "90%", }} />
          <div
            style={{
              width: "80%",
              padding: 20,
              textAlign: "center",
              fontSize: 18,
            }}
          >
            We are very excited that we have been selected to present during the
            Future Focus sessions at VetHealth Global - The Animal Health and
            Nutrition Business Conference being held, June 26 – 28, 2023 in
            Prince Edward Island, Canada. (Vet Health Global – Insight,
            Foresight, Leadership. We would love to meet as many folks as we
            can! #bovinehealth #polymerscience #start-up #unmetneeds
          </div>
        </div>
      )}
      <div className="footer">
        <div className="footer-content">
          <a
            href="mailto:kim.agnew@sorensis.com"
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <div
              style={{
                backgroundColor: "#3f5c94cf",
                borderRadius: 10,
                padding: 10,
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                height: 80,
              }}
            >
              <img
                style={{
                  width: 60,
                  cursor: "pointer",
                  color: "white",
                }}
                src={require("./assets/images/mail.png")}
              />
              Email Us
            </div>
          </a>
          <a
            href="https://pendantbio.com/"
            target={"_blank"}
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <div
              style={{
                backgroundColor: "#3f5c94cf",
                borderRadius: 10,
                padding: 10,
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                height: 80,
              }}
            >
              <img
                style={{ width: 280, cursor: "pointer" }}
                src={require("./assets/images/pendant-logo-color.png")}
              />
            </div>
          </a>
          <a
            href="https://www.facebook.com/1medicineconsulting/"
            target={"_blank"}
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <div
              style={{
                backgroundColor: "#3f5c94cf",
                borderRadius: 10,
                padding: 10,
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                height: 80,
              }}
            >
              <img
                style={{ width: 200, cursor: "pointer" }}
                src={require("./assets/images/one-medicine.png")}
              />
            </div>
          </a>
        </div>
        <div className="copyright" style={{ fontSize: 10 }}>
          Copyright &copy; 2022 Sam Madden-Hart. All Rights Reserved.
        </div>
      </div>
    </div>
  );
}

export default App;
